import Tab from '@/types/Tab'

export default function (id) {
	return [
		new Tab('pages', {
			to: { name: 'website-pages' },
			name: 'Pages',
			value: `/websites/${id}/pages`,
		}),
		new Tab('navigation', {
			to: { name: 'website-navitems' },
			name: 'Navigation',
			value: `/websites/${id}/navitems`,
		}),
		new Tab('complexes', {
			to: { name: 'website-complexes' },
			name: 'Complexes',
			value: `/websites/${id}/complexes`,
		}),
		new Tab('units', {
			to: { name: 'website-units' },
			name: 'Units',
			value: `/websites/${id}/units`,
		}),
		new Tab('tags', {
			to: { name: 'website-tags' },
			name: 'Tags',
			value: `/websites/${id}/tags`,
		}),
		new Tab('redirections', {
			to: { name: 'website-redirections' },
			name: 'Redirections',
			value: `/websites/${id}/redirections`,
		}),
		new Tab('assets', {
			to: { name: 'website-assets' },
			name: 'Assets',
			value: `/websites/${id}/assets`,
		}),
		new Tab('namespaces', {
			to: { name: 'website-namespaces' },
			name: 'Namespaces',
			value: `/websites/${id}/namespaces`,
		}),
		new Tab('strings', {
			to: { name: 'website-strings' },
			name: 'Strings',
			value: `/websites/${id}/strings`,
		}),
		new Tab('images', {
			to: { name: 'website-images' },
			name: 'Images',
			value: `/websites/${id}/images`,
		}),
	]
}
